import React from "react";
import InvoiceField from "../component/InvoiceFiled";

const ConsultingForm = ({ data = {}, onUpdate = () => {}, onSave = () => {} }) => {

  const updateField = (key, value) => {
    onUpdate(key, value);
  };

  const updateHourly = (index, key, value) => {
    const rows = [...(data.hourlyServices || [])];
    const updatedRow = { ...rows[index], [key]: value };

    const hours = parseFloat(updatedRow.hours || 0);
    const rate = parseFloat(updatedRow.rate || 0);
    updatedRow.amount = (hours * rate).toFixed(2);

    rows[index] = updatedRow;
    onUpdate("hourlyServices", rows);
  };

  const addHourly = () => {
    if ((data.hourlyServices || []).length >= 10) return;
    const rows = [
      ...(data.hourlyServices || []),
      { desc: "", hours: "", rate: "", amount: "0.00" }
    ];
    onUpdate("hourlyServices", rows);
  };

  const removeHourly = (index) => {
    const rows = [...(data.hourlyServices || [])];
    rows.splice(index, 1);
    onUpdate("hourlyServices", rows);
  };

  const updateOther = (index, key, value) => {
    const rows = [...(data.otherServices || [])];
    rows[index] = { ...rows[index], [key]: value };
    onUpdate("otherServices", rows);
  };

  const addOther = () => {
    if ((data.otherServices || []).length >= 10) return;
    const rows = [
      ...(data.otherServices || []),
      { desc: "", amount: "" }
    ];
    onUpdate("otherServices", rows);
  };

  const removeOther = (index) => {
    const rows = [...(data.otherServices || [])];
    rows.splice(index, 1);
    onUpdate("otherServices", rows);
  };

  const handleSave = () => {
    onSave(data);
  };

  return (
    <div className="space-y-6">

      <h3 className="font-bold text-lg text-[#D97706] border-b pb-2">
        Consulting Invoice
      </h3>

      <div className="grid grid-cols-2 gap-4">
        <InvoiceField
          label="Company Name"
          value={data?.companyName || ""}
          onChange={(v) => updateField("companyName", v)}
        />
        <InvoiceField
          label="Invoice Date"
          type="date"
          value={data?.date || ""}
          onChange={(v) => updateField("date", v)}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <InvoiceField
          label="Invoice #"
          value={data?.invoiceNumber || ""}
          onChange={(v) => updateField("invoiceNumber", v)}
        />
        <InvoiceField
          label="Work Order #"
          value={data?.workOrder || ""}
          onChange={(v) => updateField("workOrder", v)}
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <InvoiceField
          label="Client Name"
          value={data?.clientName || ""}
          onChange={(v) => updateField("clientName", v)}
        />
        <InvoiceField
          label="Customer ID"
          value={data?.customerId || ""}
          onChange={(v) => updateField("customerId", v)}
        />
      </div>

      <div className="border-t pt-4">
        <h4 className="text-sm font-bold text-gray-500 mb-2 uppercase">
          Hourly Services
        </h4>

        {(data.hourlyServices || []).map((item, index) => (
          <div key={index} className="grid grid-cols-4 gap-2 mb-2 items-end">
            <InvoiceField
              label="Description"
              value={item.desc || ""}
              onChange={(v) => updateHourly(index, "desc", v)}
            />
            <InvoiceField
              label="Hours"
              type="number"
              value={item.hours || ""}
              onChange={(v) => updateHourly(index, "hours", v)}
            />
            <InvoiceField
              label="Rate"
              type="number"
              value={item.rate || ""}
              onChange={(v) => updateHourly(index, "rate", v)}
            />
            <InvoiceField
              label="Amount"
              type="number"
              value={item.amount || "0.00"}
              onChange={() => {}}
              disabled
            />

            <button
              type="button"
              onClick={() => removeHourly(index)}
              className="text-red-500 text-xs"
            >
              Remove
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={addHourly}
          disabled={(data.hourlyServices || []).length >= 10}
          className="text-[#D97706] text-sm mt-2"
        >
          + Add Hourly Service (Max 10)
        </button>
      </div>

      <div className="border-t pt-4">
        <h4 className="text-sm font-bold text-gray-500 mb-2 uppercase">
          Other Services and Charges
        </h4>

        {(data.otherServices || []).map((item, index) => (
          <div key={index} className="grid grid-cols-2 gap-2 mb-2 items-end">
            <InvoiceField
              label="Description"
              value={item.desc || ""}
              onChange={(v) => updateOther(index, "desc", v)}
            />
            <InvoiceField
              label="Amount"
              type="number"
              value={item.amount || ""}
              onChange={(v) => updateOther(index, "amount", v)}
            />

            <button
              type="button"
              onClick={() => removeOther(index)}
              className="text-red-500 text-xs"
            >
              Remove
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={addOther}
          disabled={(data.otherServices || []).length >= 10}
          className="text-[#D97706] text-sm mt-2"
        >
          + Add Other Service (Max 10)
        </button>
      </div>

      <div className="flex justify-end pt-4 border-t">
        <button
          type="button"
          onClick={handleSave}
          className="bg-[#D97706] text-white px-6 py-2 rounded-md hover:opacity-90"
        >
          Save Invoice
        </button>
      </div>

    </div>
  );
};

export default ConsultingForm;
